import { render } from "./formHeader.vue?vue&type=template&id=22906bdc&scoped=true"
import script from "./formHeader.vue?vue&type=script&lang=js"
export * from "./formHeader.vue?vue&type=script&lang=js"

import "@/assets/css/style_form_page.css?vue&type=style&index=0&id=22906bdc&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22906bdc"]])

export default __exports__